import { useState, useRef, useEffect } from "react";
import {
  Dialog,
  Box,
  Button,
  Typography,
  TextField,
  Stack,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Grid,
} from "@mui/material";
import * as React from "react";
import Swal from "sweetalert2";
import Divider from "@mui/material/Divider";
import Numberimage from "../../../../Image/number.png";
import Noimage from "../../../../Image/No.png";
import DehazeIcon from "@mui/icons-material/Dehaze";
import CloseIcon from "@mui/icons-material/Close";
import signImages from "../../../../Image/sign.png";
import signsuccess from "../../../../Image/signsuccess.png";
import DocumentNoimage from "../../../../Image/documentNo.png";
import approveImages from "../../../../Image/save.png";
import SignatureCanvas from "react-signature-canvas";
import Signature_Drawing from "../../../../Image/Drawing.png";
import draw from "../../../../Image/draw.png";
import { PPHOMember } from "./IndexPendingDocument";
import Document from "../../../../Image/document.jpg";

interface IDatatModal {
  handleOpenSignModal: any;
  personalCheck: any;
  approvePriority?: any;
  approverAutocomplete?: PPHOMember | null;
  docNumber: string;
  setDocNumber: (value: string) => void;
  setopenSignModal: (value: boolean) => void;
  getSignatureByProviderTwo: any
  checkIsbutton: boolean;
  getDisplayStyle: any
  resultDetail: any
}

interface IDataResPriority {
  priority: string;
  provider_id: string;
  one_id: string;
  cid: string;
  prefix: string;
  name: string;
  email: string;
  position: string;
  comment: string;
  status: string;
  update_time: string;
  reason: string;

}

const ThirdPendingSignatureModal: React.FC<IDatatModal> = ({
  getSignatureByProviderTwo,
  handleOpenSignModal,
  personalCheck,
  approvePriority,
  approverAutocomplete,
  docNumber,
  setDocNumber,
  setopenSignModal,
  checkIsbutton,
  getDisplayStyle,
  resultDetail,
}) => {
  const [openFirstDialog, setOpenFirstDialog] = useState(false);
  const [openSecondDialog, setOpenSecondDialog] = useState(false);
  const [openThreeDialog, setOpenThreeDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false); // Dialog ยืนยัน
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false); // 🔹 Dialog 4: เซ็นสำเร็จ
  const [comment, setComment] = useState("");
  const maxCharacters = 30;
  const [openSignModal, setOpenSignModal] = useState(false);
  const [isError, setIsError] = useState(false);
  const signatureRef = useRef<SignatureCanvas | null>(null);
  const [isSigned, setIsSigned] = useState(false);
  const [penColor, setPenColor] = useState("black");
  const [selectedColor, setSelectedColor] = useState("");
  const [isLoading, setLoadingState] = useState(false);

  const [resPriority, setResPriority] = useState<any | undefined>();

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "ระบบกำลังดำเนินการ",
        html: "กรุณารอสักครู่...",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length <= maxCharacters) {
      setComment(event.target.value);
    }
  };
  const handleOpenFirstDialog = async () => {
    await getSignatureByProviderTwo()
    // console.log("personalCheck", personalCheck)
    if (personalCheck === "3") {
      setOpenFirstDialog(true);
    } else if (["1", "2", "4"].includes(personalCheck)) {
      handleOpenSignModal();
    }
  };
  const handleCloseFirstDialog = () => {
    setOpenFirstDialog(false);
  };

  const handleOpenSecondDialog = () => {
    setDocNumber("");
    setIsError(false);
    setOpenFirstDialog(false); // ปิด dialog แรก
    setOpenSecondDialog(true); // เปิด dialog ที่สอง
  };
  const handleCloseSecondDialog = () => setOpenSecondDialog(false);

  // ฟังก์ชันสำหรับเปิด Dialog 3
  const handleOpenThreeDialog = () => setOpenThreeDialog(true);
  const handleCloseThreeDialog = () => setOpenThreeDialog(false);

  // ฟังก์ชันสำหรับเปิด Dialog ยืนยัน
  const handleOpenConfirmDialog = () => setOpenConfirmDialog(true);
  const handleCloseConfirmDialog = () => setOpenConfirmDialog(false);

  const handleOpenSuccessDialog = () => setOpenSuccessDialog(true);
  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
    alert("เสร็จแล้ว"); // ✅ แสดง alert หลังจากปิด SuccessDialog
  };

  const handleSave = () => {
    // console.log("ความคิดเห็นที่บันทึก:", comment);
    setopenSignModal(true);
    setOpenSecondDialog(false);
    // handleOpenThreeDialog();

    if (!docNumber.trim()) {
      setIsError(true); // แสดง error ถ้าไม่ได้กรอก
      return; // หยุดการทำงานที่นี่
    }

    // console.log("ส่งข้อมูลสำเร็จ!");
    setOpenSignModal(true); // เปิด Modal ก็ต่อเมื่อ docNumber มีค่า
  };

  const handleConfirmSave = () => {
    // console.log("ข้อมูลถูกบันทึก");
    handleCloseThreeDialog();
    handleOpenConfirmDialog();
  };

  const handleConfirmFinal = () => {
    // console.log("ยืนยันข้อมูลสำเร็จ");
    handleCloseConfirmDialog();
    setLoadingState(true);

    setTimeout(() => {
      setLoadingState(false);
      setOpenSuccessDialog(true); // เปิด SuccessDialog

      setTimeout(() => {
        setOpenSuccessDialog(false); // ปิด SuccessDialog อัตโนมัติหลัง 1 วิ
      }, 2000);
    }, 2000);
  };

  const handleCloseSignModal = () => {
    setOpenSignModal(false);
    setOpenSecondDialog(false);
  };

  const handleSign = (signedDocNumber: string) => {
    setDocNumber(signedDocNumber);
    setOpenSignModal(false);
    // console.log("Document Signed:", signedDocNumber);
  };

  const handleSignComplete = (signedDocNumber: string) => {
    setDocNumber(signedDocNumber);
    setOpenSignModal(false);
    // console.log("Document Signed:", signedDocNumber);
  };

  const handleClearSignature = () => {
    signatureRef.current?.clear();
    setIsSigned(false);
    setComment("");
  };

  const handlePenColorChange = (color: string) => {
    setSelectedColor(color);
    setPenColor(color); // 🔹 เพิ่มการอัปเดตสีของปากกา
  };

  return (
    <>
      {/* Dialog แรก */}
      <Dialog
        open={openFirstDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleCloseFirstDialog();
        }}
        disableEnforceFocus
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "467px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseFirstDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={approveImages}
                style={{ width: 140, height: "auto", marginBottom: "20px" }}
                alt="Approved"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
              >
                การบันทึกผู้มีสิทธิ์อนุมัติ (กระทรวงสาธารณสุข)
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ textAlign: "center", color: "#636363" }}
              >
                จะทำให้คุณเป็นผู้มีสิทธิ์อนุมัติ “พยานของกระทรวงสาธารณสุข”
                โดยอัตโนมัติ ต้องการดำเนินการต่อหรือไม่
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                onClick={handleCloseFirstDialog}
                variant="outlined"
                color="error"
                sx={{ width: "120px", height: "40px", borderRadius: "20px" }}
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleOpenSecondDialog}
                variant="contained"
                sx={{
                  width: "100%",
                  height: "40px",
                  backgroundColor: "#0288D1",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#0277BD" },
                }}
              >
                ดำเนินการต่อไป
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/*  */}

      {/* Dialog ที่สอง */}
      <Dialog
        open={openSecondDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleCloseSecondDialog();
        }}
        disableEnforceFocus
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            width: "800px",
            p: 2,
          },
        }}
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center">
                <img
                  src={DocumentNoimage}
                  alt="Document"
                  style={{ width: 30, height: "auto", marginRight: 8 }}
                />
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", fontSize: "18px" }}
                >
                  เลขที่เอกสารใบสมัครเข้าร่วมโครงการ
                </Typography>
              </Box>
              <IconButton onClick={handleCloseSecondDialog}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <Typography sx={{ fontSize: "14px", p: 2 }}>
                เลขที่เอกสาร<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                placeholder="ระบุเลขที่เอกสารใบสมัครเข้าร่วมโครงการ"
                value={docNumber}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue.startsWith(" ")) return; // ป้องกัน Space ตัวแรก
                  setDocNumber(inputValue);
                  setIsError(false);
                }}
                error={isError}
                helperText={isError ? "กรุณากรอกเลขที่เอกสาร" : ""}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "15px",
                    "& fieldset": {
                      borderRadius: "15px",
                      borderColor: isError ? "#FF4545" : "#BDBDBD",
                    },
                    "&:hover fieldset": {
                      borderColor: isError ? "#FF4545" : "#0288D1",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: isError ? "#FF4545" : "#0288D1",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontSize: "14px", // ปรับขนาดตัวหนังสือของ placeholder
                    color: "#757575", // สามารถเปลี่ยนสีของ placeholder ได้
                    fontWeight: "400", // ปรับความหนาของตัวอักษร
                  },
                }}
              />
              <Divider sx={{ mt: 5 }} />
              <Typography sx={{ fontSize: "14px", p: 2 }}>
                ตัวอย่างการแสดงข้อมูล
              </Typography>
              <Grid
                sx={{
                  border: "1px solid #ACACACDE",
                  borderRadius: "10px",
                  padding: "5px",
                }}
              >
                <img
                  src={Document}
                  alt="รูปภาพ"
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "20px",
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2, mt: 4 }}>
          <Button
            onClick={handleCloseSecondDialog}
            sx={{
              width: "120px",
              height: "40px",
              color: "#FF4545",
              borderRadius: "20px",
              border: "1px solid #FF4545",
              "&:hover": { backgroundColor: "#fcefef" },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            disabled={docNumber === ""}
            onClick={() => {
              if (!docNumber.trim()) {
                setIsError(true); // แสดง error ถ้าไม่ได้กรอก
                return; // หยุดการทำงานที่นี่
              }

              handleSave(); // เรียกฟังก์ชันเมื่อกรอกข้อมูลครบ
            }}
            sx={{
              width: "120px",
              height: "40px",
              backgroundColor: docNumber === "" ? "#E6E6E6" : "#0288D1",
              color: "#fff",
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "#0277BD",
              },
            }}
          >
            ดำเนินการต่อ
          </Button>
        </DialogActions>
      </Dialog>
      {/*  */}

      {/* dialog 3 */}
      <Dialog
        open={openThreeDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleCloseThreeDialog();
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm" // ✅ ปรับขนาดจาก xs เป็น sm หรือ md
        PaperProps={{
          sx: {
            borderRadius: "16px",
            mx: 2,
            width: "500px", // ✅ ปรับความกว้างของ Dialog
          },
        }}
      >
        <Box sx={{ ml: 2 }}>
          <DialogTitle textAlign="center">
            <Box
              sx={{
                width: { xs: "100%", lg: "100%" }, // ขยายให้เต็มพื้นที่ของ Dialog
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // จัดให้อยู่บรรทัดเดียวกั
                position: "relative", // ใช้เพื่อวาง IconButton ในตำแหน่งที่ถูกต้อง
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={Noimage}
                  alt="รูปภาพ"
                  style={{ width: 30, height: "auto", marginRight: 8 }}
                />
                <Typography
                  variant="body1"
                  sx={{ color: "#000", fontWeight: "bold", fontSize: "18px" }}
                >
                  ลงนามลายเซ็นดิจิทัล
                </Typography>
              </Box>
              <IconButton onClick={handleCloseThreeDialog}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Divider />
            </Box>
          </DialogTitle>

          <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={{ p: 1, color: "#000", fontSize: "16px" }}>
              ลายเซ็นดิจิทัล
            </Typography>
            <Box
              sx={{
                width: { xs: "95%", lg: "96%" }, // ขยายเต็มพื้นที่ของ Dialog
                height: 180,
                backgroundColor: "#fff",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #99B9F3",
                position: "relative", // ต้องใช้ relative เพื่อให้ absolute ข้างในอ้างอิงตำแหน่งถูกต้อง
                overflow: "hidden", // ป้องกันเนื้อหาเกินขอบกล่อง
              }}
            >
              {/* รูปพื้นหลัง "กรุณาวาดลายเซ็น" */}
              {!isSigned && (
                <img
                  src={Signature_Drawing}
                  alt="กรุณาวาดลายเซ็น"
                  style={{
                    position: "absolute",
                    width: "20%",
                    height: "auto",
                    opacity: 0.5,
                    top: "50%", // จัดให้อยู่กึ่งกลางแนวตั้ง
                    left: "50%", // จัดให้อยู่กึ่งกลางแนวนอน
                    transform: "translate(-50%, -50%)", // จัดให้อยู่ตรงกลางพอดี
                  }}
                />
              )}

              {/* Signature Canvas */}
              <SignatureCanvas
                ref={signatureRef}
                penColor={penColor} // ใช้สีที่เลือก
                onEnd={() => setIsSigned(true)}
                canvasProps={{
                  width: 460,
                  height: 180,
                  style: {
                    borderRadius: "16px",
                    backgroundColor: "transparent",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  },
                }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "space-between",
                p: 2,
                alignItems: "center", // ให้ปุ่มอยู่ในแนวเดียวกัน
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <IconButton
                  onClick={() => handlePenColorChange("black")}
                  aria-label="black"
                  sx={{
                    width: 25,
                    height: 25,
                    backgroundColor: "black",
                    color: "#fff",
                    "&:hover": { backgroundColor: "black" },
                  }}
                >
                  {selectedColor === "black" && (
                    <img
                      src={draw}
                      alt="กรุณาวาดลายเซ็น"
                      style={{
                        position: "absolute",
                        width: "60%",
                        height: "auto",
                        opacity: 0.5,
                        filter: "brightness(0) invert(1)",
                      }}
                    />
                  )}
                </IconButton>

                <IconButton
                  onClick={() => handlePenColorChange("#0288D1")}
                  aria-label="blue"
                  sx={{
                    width: 25,
                    height: 25,
                    backgroundColor: "#0288D1",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#0288D1" },
                  }}
                >
                  {selectedColor === "#0288D1" && (
                    <img
                      src={draw}
                      alt="กรุณาวาดลายเซ็น"
                      style={{
                        position: "absolute",
                        width: "60%",
                        height: "auto",
                        opacity: 0.5,
                        filter: "brightness(0) invert(1)",
                      }}
                    />
                  )}
                </IconButton>
              </Box>

              {/* ปุ่มล้างลายเซ็น (ซ้าย) */}
              {isSigned && (
                <Button
                  onClick={handleClearSignature}
                  sx={{
                    backgroundColor: "red",
                    color: "#fff",
                    fontSize: "0.8em",
                    padding: "2px 10px",
                    textTransform: "none",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#d32f2f" },
                    ml: "12px",
                  }}
                >
                  ล้าง
                </Button>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between", // ปรับระยะห่างให้เหมาะสม
                  width: "100%", // ทำให้ขยายเต็มความกว้างของ container
                  p: 1,
                }}
              >
                <Typography sx={{ color: "#000", fontSize: "16px" }}>
                  ความคิดเห็น
                </Typography>
                <Typography
                  sx={{
                    color:
                      comment.length === maxCharacters ? "#D32F2F" : "grey.600",
                    fontSize: "14px",
                  }}
                >
                  {comment.length}/{maxCharacters}
                </Typography>
              </Box>
            </Box>

            <TextField
              variant="outlined"
              fullWidth
              multiline
              minRows={4}
              maxRows={6}
              placeholder="ระบุความคิดเห็น (ไม่จำเป็นต้องระบุ)"
              value={comment}
              onChange={handleChange} // ใช้ฟังก์ชันที่อัปเดตแล้ว
              sx={{
                width: { xs: "95%", lg: "96%" }, // ทำให้ขยายเต็มพื้นที่ของ Dialog
                backgroundColor: "#fff",
                borderRadius: "16px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #C4C4C4",
                    borderRadius: "16px",
                  },
                  "&:hover fieldset": { borderColor: "#99B9F3" },
                  "&.Mui-focused fieldset": { borderColor: "#0288D1" },
                },
              }}
              inputProps={{
                style: { fontSize: "16px" }, // ปรับขนาดตัวอักษรของข้อความที่พิมพ์
              }}
              InputProps={{
                sx: {
                  "&::placeholder": { fontSize: "16px" }, // ปรับขนาดตัวอักษรของ placeholder
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                width: "100%", // ใช้เต็มความกว้าง
                display: "flex",
                justifyContent: "center", // จัดให้อยู่ตรงกลางแนวนอน
              }}
            >
              <Button
                onClick={handleConfirmSave}
                sx={{
                  mb: 2,
                  padding: "6px 40px",
                  backgroundColor: "#0288D1",
                  color: "#fff",
                  borderRadius: "15px",
                  "&:hover": {
                    backgroundColor: "#0277BD",
                  },
                }}
              >
                บันทึก
              </Button>
            </Box>
          </DialogActions>
        </Box>
      </Dialog>

      {/* ✅ Dialog : ยืนยันการเซ็นเอกสาร */}
      <Dialog
        open={openConfirmDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseConfirmDialog();
          }
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseConfirmDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={signImages}
                alt="รูปภาพ"
                style={{
                  width: 160,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -2,
                  fontFamily: "Sarabun, sans-serif",
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ต้องการยืนยันเซ็นเอกสาร
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -1,
                  fontFamily: "Sarabun, sans-serif",
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ท่านต้องการยืนยันการเซ็นเอกสารหรือไม่
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                onClick={handleCloseConfirmDialog}
                variant="outlined"
                color="error"
                sx={{
                  mt: -1,
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                }}
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleConfirmFinal}
                variant="contained"
                sx={{
                  mt: -1,
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#0288D1",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#0288D1" },
                }}
              >
                ยืนยัน
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* ✅ Dialog : ยืนยันการเซ็นเอกสารสำเร็จ */}
      <Dialog
        open={openSuccessDialog}
        onClose={handleCloseSuccessDialog}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseSuccessDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={signsuccess}
                alt="รูปภาพ"
                style={{
                  width: 280,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ยืนยันการเซ็นเอกสารสำเร็จ
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  mt: -1,
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ทำการยืนยันเซ็นเอกสาร เรียบร้อยแล้ว
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* เปิด Dialog แรก */}
      <Button
        disabled={personalCheck === "3" && !approverAutocomplete}
        sx={{
          borderRadius: 2,
          backgroundColor:
            personalCheck === "3" && !approverAutocomplete
              ? "#E6E6E6"
              : "#0288D1",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#0277BD",
          },
          pl: 2,
          pr: 2,
          // display: personalCheck === '3' && checkIsbutton === true ? 'flex' : 'none'
          display: getDisplayStyle(resultDetail)
        }}
        onClick={handleOpenFirstDialog} // เปิด Dialog แรก
      >
        {/* {approvePriority && approvePriority.length > 0?approvePriority.map((item: any,index:number) => (
        <div> {item.priority}</div>
        )):''} */}
        {/* {approverAutocomplete?.cid} */}
        {/* {JSON.stringify(resPriority)} */}
        {/* {personalCheck === "3" || personalCheck === "4"
          ? "บันทึกข้อมูล และลงนามลายเซ็นดิจิทัล"
          : "ลงนามลายเซ็นดิจิทัล"} */}

        {personalCheck === "3"
          ? "บันทึกข้อมูล และลงนามลายเซ็นดิจิทัล"
          : "ลงนามลายเซ็นดิจิทัล"}
      </Button>
    </>
  );
};
export default ThirdPendingSignatureModal;
